/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Col, Label, Button, Row,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { post } from '../../helpers/api_helper';

function WebhookForm(props) {
  const { t } = props;

  const [loading, setLoading] = useState(false);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);
      const result = await post('/api/bc/webhook', values);

      toastr.success('Webhook created!', 'Success');
      props.onSuccess(result);
    } catch (error) {
      toastr.error(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    scope: Yup
      .string()
      .required(props.t('Scope is required')),
  });

  const jsx = (
    <Formik
      enableReinitialize
      initialValues={{ scope: '', destination: 'https://base.shopjimmy.com/api/v1/bc/webhook' }}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        save(values);
      }}
    >
      {({
        touched, errors, values,
      }) => (
        <Form className="mt-3" id="WebhookForm" autoComplete="off">
          <Row>
            <Col xxl="12">
              <div className="row mt-4 mb-4">
                <Label
                  for="name"
                  className="col-sm-2 col-form-label"
                >
                  {props.t('Scope')}
                </Label>
                <Col sm={8}>
                  <Field
                    type="text"
                    className={`form-control ${(errors.scope && touched.scope ? 'is-invalid' : '')}`}
                    id="scope"
                    placeholder="store/order/updated"
                    name="scope"
                  />
                  <ErrorMessage
                    name="scope"
                    component="div"
                    className="invalid-feedback"
                  />
                </Col>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xxl="12">
              <div className="row mt-4 mb-4">
                <Label
                  for="destination"
                  className="col-sm-2 col-form-label"
                >
                  {props.t('Callback')}
                </Label>
                <Col sm={10}>
                  <Field
                    type="text"
                    className={`form-control ${(errors.destination && touched.destination ? 'is-invalid' : '')}`}
                    id="destination"
                    placeholder="https://yourapp.example.com/webhooks"
                    name="destination"
                  />
                  <ErrorMessage
                    name="destination"
                    component="div"
                    className="invalid-feedback"
                  />
                </Col>
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );

  return jsx;
}

WebhookForm.defaultProps = {
  onSuccess: () => {},
  t: (x) => (x),
};

WebhookForm.propTypes = {
  t: PropTypes.any,
  onSuccess: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(WebhookForm));
